import { memo, useCallback, useEffect, useState } from "react"
import { useApp } from "../../contexts/AppContext"
import { useNavigate } from "react-router-dom"
import api from "../../utils/axios"
import { IBranch, IService } from "sierra"
import { Button, Divider, Grid2, IconButton, Typography, useTheme } from "@mui/material"
import Container from "../Container"
import ConfirmDialog from "../ConfirmDialog"
import { Close, Edit } from "@mui/icons-material"
import { useAuth } from "../../hooks/useAuth"

const ServiceCard = memo(({ branches, branch, service, hideButtons = false, clickable = false }: { branches: IBranch[], branch: IBranch | undefined, service: IService, hideButtons?: boolean, clickable?: boolean }) => {
    const { lang, translate, screenSize } = useApp()
    const { user } = useAuth()
    const navigate = useNavigate()
    const theme = useTheme()

    const [open, setOpen] = useState<boolean>(false)

    const handleDeleteService = useCallback((serviceId: number) => {
        api.delete(`services/${serviceId}`, { meta: { showSnackbar: true } })
            .catch(console.error)
            .finally(() => setOpen(false))
    }, [])

    const handleNavigateToOrder = useCallback(() => {
        if (!user) { navigate('/register', { state: { service: service } }) }
        else { navigate('/order', { state: { service: service } }) }
    }, [user, service])

    useEffect(() => { console.log(user) }, [])

    return (
        <Container container className={screenSize.xs ? undefined : `blurOut`} size={'grow'} minWidth={{ xs: '100%', lg: '18vw' }} flexDirection={'column'} borderRadius={2} overflow={'hidden'} bgcolor={'white'} sx={{
            '&:hover': {
                transform: 'translateY(-10px)',
            },
            transition: 'transform 0.4s ease'
        }}>
            <Grid2 height={'25vh'} padding={'5%'} sx={{
                backgroundImage: `url(${service.service_header_url})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>

                <Grid2 container display={'flex'} justifyContent={hideButtons ? 'end' : 'space-between'}>
                    {!hideButtons &&
                        <Container container size={'auto'} height={'100%'} padding={1} display={'flex'} alignItems={'center'} paddingX={0.8} spacing={2}>
                            <Grid2>
                                <ConfirmDialog
                                    title={translate('Service Delete')}
                                    text={translate('Are you sure you want to delete this service?')}
                                    open={open}
                                    setOpen={setOpen}
                                    component={<ServiceCard branches={branches} branch={branch} hideButtons={true} service={service} />}
                                    onConfirm={() => handleDeleteService(service.service_id)}>
                                    <IconButton size='small' color="error" sx={{ backgroundColor: 'rgba(255, 0, 0, 0.1)', border: '1px solid red' }} onClick={() => setOpen(true)}>
                                        <Close fontSize="small" />
                                    </IconButton>
                                </ConfirmDialog>
                            </Grid2>
                            <Grid2>
                                <IconButton size='small' color="info" sx={{ backgroundColor: 'rgba(0, 119, 255, 0.1)', border: '1px solid blue' }} onClick={() => {
                                    navigate('update', { state: { branches: branches, service: service, refresh: true } })
                                }}>
                                    <Edit fontSize="small" />
                                </IconButton>
                            </Grid2>
                        </Container>
                    }

                    <Grid2 width={{ xs: 50, lg: '4vw' }} height={{ xs: 50, lg: '4vw' }}>
                        <img src={branch?.branch_logo_url} style={{ width: '100%', height: '100%', borderRadius: 50 }} />
                    </Grid2>
                </Grid2>

            </Grid2>
            <Grid2 container size={'grow'} justifyContent={'space-between'} flexDirection={'column'} zIndex={2} padding={2} spacing={1}>
                <Grid2>
                    <Typography variant='h6' color='primary' fontWeight={'bold'}>{service.service_name[lang]} {user && user.role !== 'customer' && `(#${service.service_id})`}</Typography>
                </Grid2>
                <Divider flexItem sx={{ backgroundColor: t => t.palette.primary.main }} />
                <Grid2 paddingTop={2}>
                    <Typography variant='body2' color='textSecondary' sx={{ whiteSpace: 'pre-wrap' }}   >{service.service_desc[lang]}</Typography>
                </Grid2>
                <Grid2 container flexDirection={'column'} spacing={0} paddingTop={2}>
                    <Grid2>
                        <Typography variant='h6' color='secondary' fontWeight={'bold'}>{service.is_per_head ? translate(`Price per Person`) : translate(`Price`)}</Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='h6' sx={{ color: t => t.palette.secondary.dark }} fontWeight={'bold'}>{(service.service_price / 100).toFixed(2)} {translate("SAR")}</Typography>
                    </Grid2>

                </Grid2>
                {clickable && <Grid2 >
                    <Button fullWidth variant="contained" color="secondary" onClick={handleNavigateToOrder} sx={{
                        backgroundImage: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`, // Gradient
                        backgroundSize: '200% 200%', // Initial size for the gradient
                        color: 'white',
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundPosition: '100% 0%', // Rotate the background gradient by changing position
                        },
                        transition: 'all 0.5s ease-in-out', // Transition for background position
                    }}

                    >
                        {translate("Order Now!")}
                    </Button>
                </Grid2>}
            </Grid2>
        </Container>
    )
})

export default ServiceCard